import store from '@/store/store'
import { loading } from '@/prototypes/u/loading'
import { getProfile } from '@/http/requests/profile'
import { checkPermissions } from '@/prototypes/u/other'

export async function beforeEach (to, from, next) {
  loading.show()

  try {
    store.dispatch('updateContentNavbarClass', '')
    store.dispatch('setPageTitle', '')
    const accessToken = localStorage.getItem('accessToken')
    if (accessToken) {
      await store.dispatch('auth/setAccessToken').then(() => {
        if (to.name === 'page-login') {
          next({name: 'home'})
        }
        if (to.name !== 'Login') {
          if (from.name === null || from.name === 'Login') {
            getProfile().then((validate) => {
              if (validate.status === 200) {
                store.dispatch('auth/updateUserInfo', validate.data.data)

                if (to.meta.hasOwnProperty('permission')) {
                  if (checkPermissions(to.meta.permission)) {
                    next()
                  } else {
                    next({name: 'PageNotFound'})
                  }
                } else {
                  next()
                }
              } else {
                throw 'auth-error'
              }
            })
          } else {
            const userInfo = store.state.auth.user
            if (userInfo.active_sessions > userInfo.role.allowed_active_sessions && to.name !== 'Profile' && to.name !== 'profileActiveSessions') {
              next({name: store.getters.isMobile ? 'profileActiveSessions' : 'Profile'})
              loading.hide()
            }

            if (to.meta.hasOwnProperty('permission')) {
              if (checkPermissions(to.meta.permission)) {
                next()
              } else {
                next({name: 'PageNotFound'})
              }
            } else {
              next()
            }
          }
        } else if (!accessToken && to.name !== 'Login') {
          next({name: 'Login'})
        } else if (accessToken && to.name === 'Login') {
          next({name: 'home'})
        } else {
          next()
        }
      })
    } else if (!to.matched.some(record => record.name === 'Login')) {
      throw 'auth-error'
    } else {
      next()
    }
  } catch (e) {
    if (!to.matched.some(record => record.name === 'Login')) {
      next({
        name: 'Login'
        /* query: {redirectFrom: to.fullPath}*/
      })
      // next(false)
    } else {
      next()
    }
  }
}
